import { defineStore } from 'pinia';
import { ref } from 'vue';

import { ActivityDetailsPanelType } from '../models';

export const useActivityDetailsPanelsStore = defineStore(
  'ActivityDetailsPanelsStore',
  () => {
    // State
    const activityDetailsPanelType = ref<ActivityDetailsPanelType | undefined>(
      ActivityDetailsPanelType.None
    );

    // Actions
    function openTicketsSelectorPanel(): void {
      activityDetailsPanelType.value =
        ActivityDetailsPanelType.TicketsSelection;
    }

    function closePanel(): void {
      activityDetailsPanelType.value = ActivityDetailsPanelType.None;
    }

    return {
      // State
      activityDetailsPanelType,

      // Actions
      openTicketsSelectorPanel,
      closePanel,
    };
  }
);
